import { format } from "date-fns";
import { DataTableColumnHeader } from "../table-components/data-table-column-header";
import { formatScheduledDate } from "../../../../lib/utils";

export const scheduleAndCompletionColumns = [
  {
    id: "isScheduled",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Is Scheduled" />
    ),
    accessorFn: (row) => (row.isScheduled ? "Yes" : "No"),
  },
  {
    id: "scheduledDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Scheduled Date" />
    ),
    accessorFn: (row) =>
      row.scheduledDate
        ? formatScheduledDate(row.scheduledDate)
        : "N/A",
  },
  {
    id: "scheduledTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Scheduled Time" />
    ),
    accessorFn: (row) => {
      const time = row.scheduledTime;
      return time?.hour && time?.minute && time?.period
        ? `${time.hour}:${time.minute} ${time.period}`
        : "N/A";
    },
  },
  {
    id: "completionTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Completion Time" />
    ),
    accessorKey: "completionTime",
    cell: (info) => info.getValue() || "N/A",
  },
  {
    id: "shovellerCompletedDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Shoveller Completed Date" />
    ),
    accessorFn: (row) =>
      row.ShovelerInfo?.[0]?.shovellerCompletedDate
        ? format(
          new Date(row.ShovelerInfo[0].shovellerCompletedDate),
          "do MMM, yyyy 'at' h:mma"
        )
        : "N/A",
  },
  {
    id: "houseOwnerCompletedDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="House Owner Completed Date" />
    ),
    accessorFn: (row) =>
      row.ShovelerInfo?.[0]?.houseOwnerCompletedDate
        ? format(
          new Date(row.ShovelerInfo[0].houseOwnerCompletedDate),
          "do MMM, yyyy 'at' h:mma"
        )
        : "N/A",
  },
];
